import { render, staticRenderFns } from "./ChatText.vue?vue&type=template&id=76e55ae2&scoped=true"
import script from "./ChatText.vue?vue&type=script&lang=js"
export * from "./ChatText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e55ae2",
  null
  
)

export default component.exports